import {FeedRelatedItemRelationType, RelationType} from './relatedItems.types';

export const FeedRelationTypeValueToName: Record<FeedRelatedItemRelationType, string> = {
  [FeedRelatedItemRelationType.ProductSet]: 'Product Set',
  [FeedRelatedItemRelationType.TopItems]: 'Top Items List',
  [FeedRelatedItemRelationType.FieldToItems]: 'Category Top Items List',
};

export const relationTypeToUiName: Partial<Record<RelationType, string>> = {
  [RelationType.ProductSet]: 'Product Set',
  [RelationType.TopItems]: 'Top Items',
  [RelationType.CategoryTopItems]: 'Category Top Items',
};
